import { DataActiveStatusEnum } from "../../Category/types";
import { IData, PackageState, PackageTypeEnum } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  price: "",
  taxRate: "",
  status: DataActiveStatusEnum.INACTIVE,
  type: PackageTypeEnum.Customizable,
  subCategoryId: "",
  items: [],
  itemsForm: {
    groupId: "",
    productId: "",
    remove: false,
    groupTitle: "",
    productTitle: ""
  },
  allergicImages: [],
  stickers: [],
  images: [],
  featuredImage: [],
  subCategoryTitle: "",
  shipmentCapacity: "",
};

export const initialState: PackageState = {
  formData: {
    ...defaultFormData,
  },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
  itemsLoading: false,
};
